import { create } from 'zustand';

const useGlobalStore = create((set, get) => ({
  userID: '24',
  producerID: '016026601',
  salesDivison: 'ISD',
  domain: 'https://localhost:44380/',
}));

export { useGlobalStore };
